// extracted by mini-css-extract-plugin
export default {"bubblesview":"bd1ce3261521a67b7be1","bubble":"b8348098bb2407337adf"};